import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { BASE_URL } from '../../../config';
import ReactModal from 'react-modal';
import ImageSlider from '../../ImageSlider';
@observer
class StationImageView extends React.Component {

  @observable selectedImage = 0;
  @observable showFullScreen = false;

  componentWillReceiveProps() {
    this.selectedImage = 0;
  }

  _renderImageFullScreen = () => {
    const styles = {
      modal: {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
        },
        content: {
          backgroundColor: 'transparent',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          overflow: 'hidden',
        },
      },
    };
    return <ReactModal
      isOpen
      onRequestClose={() => this.showFullScreen = false}
      style={styles.modal}
    >
      <div>
        <span
          style={{ position: 'absolute', top: '10px', right: '20px', fontSize: 'x-large' }}
          className="fa fa-remove"
          onClick={() => this.showFullScreen = false}
        />
        <ImageSlider
          baseUrl={`${BASE_URL}/images`}
          images={this.props.images.map((image) => {
            return {
              ...image,
              source: `${image.name}`,
            }
          })}
          onChangeImage={(image, newIndex) => {
            this.selectedImage = newIndex;
          }}
          noSlider={true}
          play={false}
          width={'80vw'}
          height={'90vh'}
          selectedIndex={this.selectedImage}
        />
      </div>
    </ReactModal>
  }

  render() {
    let { images, deleteImage } = this.props;
    if (!images.length) return <div />;

    if (this.showFullScreen) return this._renderImageFullScreen();

    return (
      <div className='station-image-slider'>
        {images.length > 1 && <div className='station-image-slide-selector'>
          {images.map((image, i) => (
            <div key={i} className={`image-slide-item ${this.selectedImage === i ? 'image-slide-active' : ''}`} onClick={() => this.selectedImage = i} >
              <div style={{
                height: '100px',
                width: '100px',
                backgroundImage: `url('${BASE_URL}/images/${image.name}')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                borderRadius: '12px',
              }} />
            </div>
          ))}
        </div>}
        <div className="imageContainer full-width">
          {!!deleteImage && <div className="imageRemove">
            <span className="fa fa-remove" onClick={() => deleteImage(images[this.selectedImage].id)} />
          </div>
          }
          <div className='imageExpand'>
            <span className='fa fa-expand' onClick={() => this.showFullScreen = true} />
          </div>
          <img src={`${BASE_URL}/images/${images[this.selectedImage].name}`} style={{ width: '100%' }} alt='not-found' />
        </div>
      </div>
    )
  }
}

export default StationImageView;


// WEBPACK FOOTER //
// ./src/components/Station/MetaData/StationImageView.js